import { render, staticRenderFns } from "./UserHeader.vue?vue&type=template&id=f27fb444&scoped=true"
import script from "./UserHeader.vue?vue&type=script&lang=js"
export * from "./UserHeader.vue?vue&type=script&lang=js"
import style0 from "./UserHeader.vue?vue&type=style&index=0&id=f27fb444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27fb444",
  null
  
)

export default component.exports